// extracted by mini-css-extract-plugin
module.exports = {"avatar":"_5D3F_KQ7","avatar__icon":"_5D1n5vW2","avatar__img":"_5D2lSH_-","default":"_5DIdBwJz","has-border":"_5D3MhknS"};